import styled from 'styled-components/native';
import { useField, useFormikContext } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { View, Text, TextInput, Modal, Pressable } from 'react-native';
import { Link } from 'app/src/utils/routing';

import colors, {
  elRed,
  elGray,
  elGreen
} from '../../styles/colors';

export const DefaultModal = styled(Modal)`

`

export const CenteredView = styled(View)`
flex:1;
justify-content: center;
align-items: center;
background-color: rgba(0,0,0,0.5);
`

export const ModalView = styled(Pressable)`
width: fit-content;
height: fit-content;
max-height: 99vh;
background-color: white;
border-radius: 5;
border: 2px solid black;
shadow-color: #000;
shadow-offset: {
  width: 0,
  height: 2,
}
shadow-opacity: 0.25;
shadow-radius: 4;
elevation: 5;
cursor: default;
max-width: 75%;
`;

export const ModalHeader = styled(View)`
width: 100%;
height: 25px;
flex-direction: row;
background-color: ${props => props.pendingResponse ? elRed : elGreen};
padding-left: 15px;
padding-right: 10px;
margin-bottom: 20px;
justify-content: space-between;
`;

export const ModalContent = styled(View)`
margin-left: 20px;
margin-right: 20px;
min-width: 600px;
overflow: auto;
`;

export const CancelX = styled(Text)`
font-weight: bold;
font-size: 20px;
color: white;
`;

export const BoldText = styled(Text)`
font-weight: bold;
`;

export const HeaderText = styled(Text)`
color: white;
font-size: 20px;
font-weight: bold;
`;

export const ModalContainer = styled(Pressable)`
  width: ${props => props.width}
`;

export const UsersModal = styled(Modal)`
  width: 200px;
`;

export const ChatContainer = styled(View)`
  height: fit-content;
  width: fit-content;
  max-width: 80%;
  gap: 10px;
  flex-direction: row;
  align-self: flex-end;
  justify-content: flex-end;
  align-items: flex-end;
  position: fixed;
  bottom: 0;
  right: 0;
`;

export const PendingConversationsContainer = styled(View)`
  display: flex;
  justify-content: flex-end;
  width: ${props =>
    getPendingConversationsWidth(props.showConversations,
      props.pendingConversations, props.openConversations
    )
  }
  max-height: 500px;
`;

export const ChatBoxes = styled(View)`
  display: flex;
  flex-direction: row;
  margin-right: 0.25%;
  margin-left: 0.25%;
  padding-top: 50px;
  padding-left: 20px;

  max-height: 430px;
  max-width: ${props => props.showConversations ? '48%' : '75%'};
  width: ${props =>
    getChatBoxesWidth(props.showConversations, props.pendingConversations,
      props.openConversations
    )
  };
  gap: 10px;
  overflow-x: scroll;
`;

export const ChatModal = styled(View)`
  width: 100%;
  height: fit-content;
  height: 330px;
  max-height: 500px;
  background-color: white;
  border-radius: 5;
  border: 2px solid black;
  elevation: 5;
  cursor: default;
  max-width: 100%;
  shadow-color: #000;
  box-shadow: 5px 5px 5px #000;
  shadow-offset: {
    width: 0,
    height: 2,
  }
  shadow-opacity: 0.75;
  shadow-radius: 5;
  z-index: 100;
  display: flex !important;
  align-self: flex-end;
  bottom: 10px;
  right: 20px;
`;

export const CollapsedChat = styled(Pressable)`
  width: 150px;
  font-size: 20px;
  color: #fff;
  font-weight: bold;
  shadow-color: #000;
  elevation: 5;
  shadow-offset: {
    width: 0,
    height: 2,
  }
  shadow-opacity: 0.75;
  shadow-radius: 5;
  box-shadow: 1px -1px 5px #000;
  background-color: ${props => props.pendingResponse ? elRed : elGreen};
  padding: 5px;
  bottom: 0;
  align-self: flex-end;
  z-index: 100;
  right: 20px;
  border: 1px solid black;
`;

export const ChatPending = styled(View)`
  width: fit-content;
  font-size: 20px;
  color: #ffffff;
  font-weight: bold;
  shadow-color: #000;
  elevation: 5;
  shadow-offset: {
    width: 0,
    height: 2,
  }
  shadow-opacity: 0.75;
  shadow-radius: 5;
  box-shadow: 1px -1px 5px #000;
  background-color: ${props => props.pendingResponse ? elRed : colors.elGreen}
  padding: 5px;
  bottom: 0;
  align-self: flex-end;
  z-index: 100;
  right: 20px;
  border: 1px solid black;
  overflow-y: scroll;
`;

export const ChatPendingList = styled(View)`
  width: fit-content;
  height: fit-content;
  font-size: 20px;
  color: #ffffff;
  font-weight: bold;
  shadow-color: #000;
  elevation: 5;
  shadow-offset: {
    width: 0,
    height: 2,
  }
  shadow-opacity: 0.75;
  shadow-radius: 5;
  box-shadow: 1px -1px 5px #000;
  background-color: ${props => props.pendingResponse ? elRed : colors.elGreen}
  padding: 5px;
  margin-bottom: 25px;
  bottom: 0;
  align-self: flex-end;
  z-index: 100;
  right: 20px;
  border: 1px solid black;
`;

function getPendingConversationsWidth(showConversations, pendingConversations, openConversations) {
  if(pendingConversations && openConversations > 0) {
    return showConversations ? '48%' : 'fit-content';
  }else {
    // return showConversations ? '48%' : '23%';
    return 'fit-content'
  }
}

function getChatBoxesWidth(showConversations, pendingConversations, openConversations) {
  if(pendingConversations && openConversations > 0) {
    if(showConversations && openConversations > 1) {
      return '42%';
    }else {
      return 'fit-content';
    }
  }else {
    // return openConversations.length === 1 ? 'fit-content' : '48%';
    return 'fit-content'
  }
}
